import api from '../api/axios'

const billingService = {
  async createCheckout() {
    const { data } = await api.post('/billing/checkout')
    return data
  },

  async getStatus() {
    const { data } = await api.get('/billing/status')
    return data
  },

  async cancel() {
    const { data } = await api.post('/billing/cancel')
    return data
  }
}

export default billingService
